export const AUTOCOMPLETE_CATEGORIES = {
  '0': {
    label: 'productOption'
  },
  '1': {
    label: 'productTestOption'
  },
  '2': {
    label: 'auditOption'
  }
};